/**
 * PublicRoute Component
 *
 * Wrapper for public-only routes (like login).
 * Redirects authenticated users to home page.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import { LoadingScreen } from '@/shared/components/LoadingScreen';

interface PublicRouteProps {
  children: ReactNode;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isInitialized, isLoading } = useAuth();

  // Show loading screen while initializing (prevents flash)
  if (!isInitialized || isLoading) {
    return <LoadingScreen />;
  }

  // Redirect to home if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
